// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"vu_a bhb_b bhb_ux"};